import moment from "moment-timezone";
import {reverseEnum} from "../components/Utility";
import {PaymentStatus} from "../enums/enums";
import Image from "../components/common/Image";
import React from "react";

const timezone = 'Asia/Kolkata';
export const getTableColumns = ({ActionDropdown, deleteHandler}) => {
    let tableColumns = [
        {header: "Vendor", field: "vendor"},
        {header: "Total amount", field: "totalAmount"},
        {header: "Initial paid amount", field: "paidAmount"},
        {header: "Due amount", field: "dueAmount"},
        {header: "Total paid payment", field: "totalPayment"},
        {header: "Payment method", field: "paymentMethod"},
        {header: "Purchase date", field: "purchaseDate"},
        {header: "Status", field: "status"},
    ];

    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} view={true} onDelete={deleteHandler} addDuplicate={true}/>,
    });

    return tableColumns;
};

export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        totalAmount: (
            <div className={item.creator === "Vendor" ? "creator_vendor" : ""}>
                {item.totalAmount}
            </div>
        ),
        vendor: item.vendor?.name,
        paidAmount: item.paidAmount,
        dueAmount: item.dueAmount,
        paymentMethod: item.paymentMethod,
        totalPayment: item.totalPayment,
        purchaseDate: item.purchaseDate ? moment(item.purchaseDate).tz(timezone).format('MMM DD, YYYY, hh:mm A') : "-",
        status: item.dueAmount > 0 ? "Pending" : "Paid",
    }));
};

export const getDetailData = ({item, vendors}) => {
    if (!item) return {details: {}};
    const isPdf = item?.receipt?.toLowerCase().endsWith(".pdf");
    return {
        details: {
            Vendor: vendors[item.vendor],
            totalAmount: item?.totalAmount,
            initialPaidAmount: item?.paidAmount,
            dueAmount: item?.dueAmount,
            totalPaidPayment: item?.totalPayment,
            paymentMethod: item?.paymentMethod,
            paymentDate: item.purchaseDate ? moment(item.purchaseDate).tz(timezone).format('MMM DD, YYYY, hh:mm A') : "-",
            paymentStatus: reverseEnum(PaymentStatus)[item.paymentStatus],
            note: item.note,
            receipt: item.receipt
                ? isPdf ? (
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => window.open(`${process.env.REACT_APP_API_BASE_URL}/${item.receipt}`, "_blank")}
                    >
                        View PDF
                    </button>
                ) : (
                    <Image
                        className="border rounded-2"
                        src={item.receipt}
                        alt={item.name}
                    />
                )
                : "-",
        }
    };
}

export const getOrderItemTableColumns = () => {
    let tableColumns = [
        {header: "Product", field: "product"},
        {header: "Quantity", field: "quantity"},
        {header: "Price", field: "price"},
        {header: "Unit Price", field: "unitPrice"},
    ];
    return tableColumns;
};

export const getOrderItemTableData = ({products = [], productList = {}}) => {
    if (!Array.isArray(products)) return [];
    return products.map((item) => {
        const productName = productList[item.product] || '';
        return {
            product: productName,
            quantity: item.quantity,
            price: item.price,
            unitPrice: item.unitPrice,
        };
    });
};

export const getSettlementTableColumns = () => {
    let tableColumns = [
        {header: "Type", field: "type"},
        {header: "Initial Payment", field: "initialPayment"},
        {header: "Custom Payment", field: "customPayment"},
        {header: "Partial Amount", field: "partialAmount"},
        {header: "Vendor Advanced", field: "vendorAdvanced"},
        {header: "Settlement Date", field: "settlementDate"},
    ];
    return tableColumns;
};

export const getSettlementTableData = ({settlement = [], productList}) => {
    if (!Array.isArray(settlement)) return [];
    return settlement.slice().reverse().map((item) => ({
        id: item.id,
        type: item.type,
        initialPayment: item.initialPayment,
        customPayment: item.customPayment,
        partialAmount: item.partialAmount,
        vendorAdvanced: item.vendorAdvanced,
        settlementDate: moment(item.settlementDate).tz(timezone).format('MMM DD, YYYY, hh:mm A'),
    }));
};
